module.exports = __webpack_public_path__ + "img/home.3c64ae66.svg";